export const preprocessMarkdown = (md) => {
    if (!md) return '';
    return md
      .replace(/^```markdown\s*/i, '')  // remove opening ```
      .replace(/```$/, '')              // remove closing ```
      .trim();
  };
  
  export const formatPostedOnDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "-";
    const now = new Date();
    const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffDays = Math.floor((nowOnly - dateOnly) / (1000 * 60 * 60 * 24));
  
    if (diffDays > 0 && diffDays <= 5) {
      return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
    }
  
    return date.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  export const extractCandidateName = (mph_name) => {
    if (!mph_name) return '-';
    const parts = mph_name.split(' - ');
    const filtered = parts.filter(Boolean);
    if (filtered.length < 2) return mph_name;
    return filtered[filtered.length - 1].trim();
  };

  